import conferences from "assets/img/25/Actividades/Conferencias.jpg";
import workshops from "assets/img/25/Actividades/Talleres.jpg";
import meditations from "assets/img/25/Actividades/Meditaciones.jpg";
import consciousfood from "assets/img/25/Actividades/Alimentación Consciente.png";
import excursions from "assets/img/25/Actividades/Excursiones.jpeg";
import celebrations from "assets/img/25/Actividades/Celebración y Música.png";

export default [
  {
    title: {
      en: "Conferences",
      es: "Conferencias",
    },
    description: {
      en: "Genuine inspiration your soul needs to hear.",
      es: "Inspiración genuina que tu alma necesita escuchar.",
    },
    img: conferences,
  },
  {
    title: {
      en: "Workshops",
      es: "Talleres",
    },
    description: {
      en:
        "Witness your consciousness expand through community sharing and learning.",
      es:
        "Experimenta cómo crece tu consciencia al compartir y aprender en comunidad.",
    },
    img: workshops,
  },
  {
    title: {
      en: "Meditations",
      es: "Meditaciones",
    },
    description: {
      en: "A profound pause to rediscover your essence.",
      es: "Una pausa profunda para redescubrir tu esencia.",
    },
    img: meditations,
  },
  {
    title: {
      en: "Conscious food",
      es: "Alimentación consciente",
    },
    description: {
      en: "Nourishing body and soul.",
      es: "Sabores que crean recuerdos profundos y conexiones auténticas.",
    },
    img: consciousfood,
  },
  {
    title: {
      en: "Excursions",
      es: "Excursiones",
    },
    description: {
      en:
        "The landscapes, energy, every step will remind you who you truly are. Your spirit will return renewed.",
      es:
        "El paisaje, la energía, cada paso dado, te recordará quién eres realmente. Tu espíritu regresará renovado.",
    },
    img: excursions,
  },
  {
    title: {
      en: "Celebrations & music",
      es: "Celebración y música",
    },
    description: {
      en: "Feel, perhaps for the first time, authentic spiritual belonging.",
      es:
        "Sentirás cómo las diferencias desaparecen y solo queda espacio para celebrar el amor, la alegría y la conexión profunda.",
    },
    img: celebrations,
  },
];
